exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-wrapper{font-size:1.2rem}.row-item{padding:5px 0}.red{color:#e53e3e}.sub-section{padding-left:20px}.title{font-size:1.4rem;padding-bottom:10px}.price{font-size:1.6rem}.button-red{background:#e53e3e;color:#fff;font-size:1rem;padding:8px 12px;border-radius:.25rem;margin-top:30px}label{padding-left:10px}input[type=number]{padding:0;width:80px;text-align:center}input{width:100%;border-bottom:1px solid #dae1e7;margin:10px 0}input:focus{border-bottom:1px solid #e53e3e}textarea{padding:10px;height:200px;margin:5px 0;border:1px solid #dae1e7}", ""]);

// exports
